<template>
  <div class="coupon-item" :class="couponItemClass" @click="clickTarget($event, coupon)">
    <div class="coupon-price-bg"></div>
    <div class="coupon-item-inner">
      <div class="left-price">
        <img class="expire-date-left" v-if="size === 'small' && expiryDiffDay <= 2" :src="expiredDateUrl.small">
        <div class="price-content">
          <span class="price-sign">￥</span>
          <span class="price-num">{{ coupon.cash_reduce / 100 }}</span>
        </div>
      </div>
      <div class="right-content">
        <div class="coupon-name" v-if="coupon.reach_reduce">满{{ coupon.reach_reduce / 100 }}元可用</div>
        <div class="coupon-name" v-else>无门槛</div>
        <div class="coupon-desc">
          <div class="coupon-desc-content">
            <span>{{ coupon.desc }}</span>
            <img class="tip-icon-question" v-if="(alwaysShow && coupon.scope) || coupon.scope === 2 || (showMore && coupon.scope && coupon.desc && coupon.desc.length > 9)" src="../../assets/imgs/coupon/usage.png" @click.stop="clickTarget($event)">
          </div>
        </div>
        <div class="coupon-duration">
          <template v-if="valid">
            <span v-if="coupon.start_date">{{ coupon.start_date }}</span>
            <span v-else>即日起</span>
            <span class="to">至</span>
            <span>{{ coupon.end_date }}</span>
            <img class="expire-date" v-if="size !== 'small' && expiryDiffDay <= 2" :src="expiredDateUrl.other">
          </template>
          <template v-else>
            <span>{{ coupon.expiry_date }}</span> <span>{{ coupon.expiry_desc }}</span>
          </template>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import expiredOther1 from '../../assets/imgs/coupon/expired_other_1.png';
import expiredOther2 from '../../assets/imgs/coupon/expired_other_2.png';
import expiredOther3 from '../../assets/imgs/coupon/expired_other_3.png';
import expiredEnsure1 from '../../assets/imgs/coupon/expired_ensure_1.png';
import expiredEnsure2 from '../../assets/imgs/coupon/expired_ensure_2.png';
import expiredEnsure3 from '../../assets/imgs/coupon/expired_ensure_3.png';

import couponScope from './coupon-scope';

export default {
  name: 'coupon-item',
  props: {
    size: {
      type: String,
      default: 'normal',
    },
    valid: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    coupon: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    showMore: {
      type: Boolean,
      default: true,
    },
    alwaysShow: {
      type: Boolean,
      default: false,
    },
    couponIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showUsage: false,
      urls: {
        expiredOther1,
        expiredOther2,
        expiredOther3,
        expiredEnsure1,
        expiredEnsure2,
        expiredEnsure3,
      },
    };
  },
  computed: {
    couponItemClass() {
      return {
        middle: this.size === 'middle',
        small: this.size === 'small',
        invalid: !this.valid,
        expired: this.coupon.expiry_desc === '已过期',
        used: this.coupon.expiry_desc === '已使用',
        selected: this.selected,
        selectable: this.selectable,
      };
    },

    expiredDateUrl() {
      return {
        small: this.urls[`expiredEnsure${this.expiryDiffDay + 1}`],
        other: this.urls[`expiredOther${this.expiryDiffDay + 1}`],
      };
    },

    expiryDiffDay() {
      const now = new Date();
      const today = new Date(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`).setHours(8);
      const expirdDate = new Date(this.coupon.end_date).getTime();
      const aDay = 24 * 60 * 60 * 1000;
      const diffDay = (expirdDate - today) / aDay;
      return diffDay;
    },
  },
  methods: {
    showTipsModal(event, open) {
      const param = {
        title: '限指定国家使用',
        desc: this.coupon.desc,
        position: event.target.getBoundingClientRect(),
      };
      if (open) {
        couponScope.show(param);
      } else {
        couponScope.hide();
      }
    },

    // 区分点击对象，执行不同操作
    clickTarget(event, coupon) {
      if (event.target.className === 'tip-icon-question') {
        this.couponExplain();
      } else {
        this.selectCoupon(coupon);
      }
    },

    // 选择优惠券
    selectCoupon(coupon) {
      if (this.selectable) {
        this.$emit('couponExport', 'selectCoupon', coupon);
      }
    },

    // 显示优惠券说明弹窗
    couponExplain() {
      this.$emit('couponExport', 'couponExplain', {
        isShowCouponExplain: true,
        couponIndex: this.couponIndex,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variable";
.coupon-item {
  * {
    line-height: 1;
  }
  height: 96px;
  width: 380px;
  background-color: #ffffff;
	box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
	border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  position: relative;
  user-select: none;
  &.middle {
    width: 366px;
    .coupon-item-inner {
      width: 360px;
    }
  }

  // 这里的selected和下面的selectable的hover是一样的，需要同步
  &.selected {
    box-shadow: 0px 1px 4px 0px rgba(250, 125, 49, 0.25);
    border: solid 1px #fc7906;
    background-image: url("../../assets/imgs/coupon/ensure-select.png");
    background-position: right top;
    background-repeat: no-repeat;
    &.small {
      .coupon-price-bg {
        height: 79px;
        width: 89px;
      }
    }
  }
  &.selectable {
    cursor: pointer;

    // 这里的selectable的hover和上面的selected是一样的，需要同步
    &:hover {
      box-shadow: 0px 1px 4px 0px rgba(250, 125, 49, 0.25);
      border: solid 1px #fc7906;
      &.small {
        .coupon-price-bg {
          height: 79px;
          width: 89px;
        }
      }
    }
  }
  &.small {
    width: 260px;
    height: 80px;
    .coupon-item-inner {
      width: 255px;
      height: 75px;
      .left-price {
        width: 90px;
        .price-content {
          .price-sign {
            font-size: 16px;
          }
          .price-num {
            font-size: 32px;
          }
        }
      }
      .right-content {
        padding-left: 5px;
        .coupon-name {
          padding: 12px 0 8px 0;
          font-size: 14px;
        }
        .coupon-duration {
          margin-top: 8px;
          font-size: 12px;
          line-height: 12px;
        }
      }
    }
    .coupon-price-bg {
      height: 80px;
      width: 90px;
    }
  }
  &.invalid {
    background-position: top right;
    background-repeat: no-repeat;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
    .coupon-price-bg {
      background-image: url("../../assets/imgs/coupon/my-coupon-bg-expired.png");
    }
    .coupon-item-inner {
      border: solid 1px #f0f0f0;
    }
  }
  &.expired,
  &.used {
    z-index: 11;
    .right-content {
      background-image: url("../../assets/imgs/coupon/my-coupon-strip-expired.png") !important;
      .coupon-name {
        color: #cfcfcf !important;
      }
      .coupon-desc {
        color: #cfcfcf !important;
      }
      .coupon-duration {
        color: #cfcfcf !important;
      }
    }
  }
  &.expired {
    background-image: url('../../assets/imgs/coupon/expired.png');
  }
  &.used {
    background-image: url('../../assets/imgs/coupon/used.png');
  }
  .coupon-price-bg {
    background-image: url("../../assets/imgs/coupon/modal-bg.png");
    width: 125px;
    height: 96px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .coupon-item-inner {
    height: 90px;
    width: 374px;
    border-radius: 2px;
    border: solid 1px rgba(255, 121, 6, .3);
    position: relative;
    display: flex;
    .left-price {
      width: 122px;
      padding-right: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 2;
      font-weight: 600;
      color: white;
      .expire-date-left {
        position: absolute;
        left: -2px;
        top: 7px;
      }
      .price-content {
        display: flex;
        align-items: baseline;
        .price-sign {
          font-weight: 600;
          font-size: 22px;
        }
        .price-num {
          font-size: 44px;
        }
      }
    }
    .right-content {
      position: relative;
      z-index: 2;
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-left: 15px;
      background-image: url("../../assets/imgs/coupon/modal-bg-strip.png");
      background-repeat: no-repeat;
      background-position: right center;
      overflow: hidden;
      .coupon-name {
        padding: 13px 0;
        font-size: 16px;
        color: #333;
      }
      .coupon-desc {
        font-size: 13px;
        color: #aaa;
        padding-right: 25px;
        overflow: hidden;
        .coupon-desc-content {
          display: flex;
          align-items: center;
          overflow: hidden;
          span {
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          img.tip-icon, img.tip-icon-question {
            width: 14px;
            height: 14px;
            cursor: pointer;
          }
        }
      }
      .coupon-duration {
        margin-top: 10px;
        font-size: 13px;
        margin-top: 12px;
        color: #aaa;
        display: flex;
        align-items: center;
        .expire-date {
          margin-left: 3px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coupon/coupon.vue